module.exports = __webpack_public_path__ + "static/media/waschbecken.20da796c.jpg";